import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { PageInfo, PendencyTypeByIdGQL, PendencyTypeOrderByInput, PendencyTypesPageGQL, PendencyTypesPageQuery } from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import { BasePaginationService } from '../../../core/components/pagination/pagination.type'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class PendencyTypeService implements BasePaginationService {

  public search$: Subject<void> = new Subject()

  public readonly filterForm = new FormGroup({
    nameContains: new FormControl(''),
    descriptionContains: new FormControl(''),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<PendencyTypeOrderByInput>(PendencyTypeOrderByInput.NameAsc)
  public isFiltering = signal<boolean>(false)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public isLoading = signal<boolean>(false)

  public readonly pendencyTypesPageGQL = inject(PendencyTypesPageGQL)
  public readonly getPendencyTypeByIdGQL = inject(PendencyTypeByIdGQL)

  public async searchPage(): Promise<Apollo.QueryResult<PendencyTypesPageQuery>> {
    const { nameContains, descriptionContains, archived } = this.filterForm.value

    const observable$ = this.pendencyTypesPageGQL.fetch({
      variables: {
        where: {
          nameContains,
          descriptionContains,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async getById(id: string) {
    const { data } = await firstValueFrom(this.getPendencyTypeByIdGQL.fetch({ variables: { id } }))
    return data?.pendencyType
  }
}
